// ModalCalendar.jsx
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import moment from "moment";

/*────────── COMPONENTE ──────────*/
export default function ModalCalendar({
  selected,
  isOpen,
  onClose,
  events = [],
  onEdit = (ev) => console.log("Editar", ev),
  onDelete = (ev) => console.log("Eliminar", ev),
}) {
  /*────────── ESTADOS ──────────*/
  const [activeTab, setActiveTab] = useState("eventos");
  const [ctxMenu, setCtxMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    event: null,
  });

  /* cerrar menú al hacer clic fuera */
  useEffect(() => {
    const handleOutside = () => setCtxMenu((m) => ({ ...m, visible: false }));
    if (ctxMenu.visible) document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, [ctxMenu.visible]);

  /*────────── HANDLERS ──────────*/
  const handleMenuButton = (e, ev) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();

    setCtxMenu({
      visible: true,
      x: rect.right - 144, // alineado al borde derecho del botón (ancho=144 px)
      y: rect.bottom + 4, // 4 px de separación vertical
      event: ev,
    });
  };

  const handleEdit = () => {
    onEdit(ctxMenu.event);
    setCtxMenu({ ...ctxMenu, visible: false });
  };
  const handleDelete = () => {
    onDelete(ctxMenu.event);
    setCtxMenu({ ...ctxMenu, visible: false });
  };

  /*────────── ESTILOS ──────────*/
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.3)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1005,
    },
    content: {
      position: "relative",
      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
      background: "#fff",
      borderRadius: 12,
      width: "90%",
      maxWidth: 420,
      padding: 0,
      border: "none",
      fontFamily: "Inter, sans-serif",
    },
  };

  const modalHeaderStyle = {
    display: "flex",
    alignItems: "center",
    padding: "5px 15px",
    borderBottom: "1px solid #E5E7EB",
  };
  const closeButtonStyle = {
    marginLeft: "auto",
    backgroundColor: "#F3F4F6",
    border: "none",
    borderRadius: "50%",
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  };
  const tabsContainerStyle = {
    display: "flex",
    justifyContent: "space-around",
    borderBottom: "1px solid #D1D5DB",
    paddingBottom: 2,
  };
  const tabButtonStyle = {
    background: "none",
    border: "none",
    padding: "10px 12px 8px",
    fontSize: 16,
    cursor: "pointer",
    color: "#6B7280",
    fontWeight: 600,
    position: "relative",
  };
  const activeTabStyle = { color: "#6B7280", fontWeight: 600 };
  const activeTabUnderlineStyle = {
    position: "absolute",
    bottom: -3,
    left: 0,
    width: "100%",
    height: 2,
    background: "#6B7280",
    borderRadius: 1,
  };

  const eventListContainerStyle = {
    padding: "20px 15px",
    overflowY: "auto",
    height: 280,
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE 10+/Edge Legacy
  };

  /*────────── RENDER ──────────*/
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Calendario Modal"
    >
      {/* Encabezado */}
      <div style={modalHeaderStyle}>
        <h2 style={{ fontSize: 24, fontWeight: 700 }}>Calendario</h2>
        <button onClick={onClose} style={closeButtonStyle}>
          <i
            className="bi bi-x-lg"
            style={{ fontSize: 14, color: "#374151" }}
          />
        </button>
      </div>

      {/* Tabs (solo visual) */}
      <div style={tabsContainerStyle}>
        <button
          onClick={() => setActiveTab("eventos")}
          style={{
            ...tabButtonStyle,
            ...(activeTab === "eventos" && activeTabStyle),
          }}
        >
          Eventos
          {activeTab === "eventos" && <div style={activeTabUnderlineStyle} />}
        </button>

        <button
          onClick={() => setActiveTab("festivos")}
          style={{
            ...tabButtonStyle,
            ...(activeTab === "festivos" && activeTabStyle),
          }}
        >
          Festivos
          {activeTab === "festivos" && <div style={activeTabUnderlineStyle} />}
        </button>
      </div>

      {/* ---------- Lista de eventos / festivos ---------- */}
      <div style={eventListContainerStyle}>
        {(() => {
          /* ➊ Filtramos según la pestaña ----------------------- */
          /* ➊ Filtramos según la pestaña ----------------------------------- */
          const filtered = events.filter((ev) => {
            /* ── pestaña “Eventos” ─────────────────────────── */
            if (activeTab === "eventos") {
              return ev.resource !== "festivo"; // todo excepto festivos
            }

            /* ── pestaña “Festivos” ────────────────────────── */
            if (ev.resource !== "festivo") return false; // sólo festivos

            const hoy = moment().startOf("day");
            const limite = moment().add(3, "months").endOf("day");

            const inRange = moment(ev.start).isBetween(hoy, limite, null, "[]");
            const isPicked =
              selected && moment(ev.start).isSame(selected, "day");

            /*  ⬅️  mostramos si es festivo próximo O el día pulsado  */
            return inRange || isPicked;
          });

          /* ➋ Si NO hay festivos próximos mostramos imagen ------ */
          if (activeTab === "festivos" && filtered.length === 0) {
            return (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <img
                  src="/img/undraw_no-data.svg"
                  alt="Sin próximos festivos"
                  style={{ width: 140, opacity: 0.6 }}
                />
                <p style={{ color: "#9CA3AF", marginTop: 16 }}>
                  No hay días festivos próximos
                </p>
              </div>
            );
          }

          if (activeTab === "eventos" && filtered.length === 0) {
            return (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <img
                  src="/img/undraw_no-data.svg"
                  alt="Sin eventos"
                  style={{ width: 140, opacity: 0.6 }}
                />
                <p style={{ color: "#9CA3AF", marginTop: 16 }}>
                  No hay eventos en esta fecha
                </p>
              </div>
            );
          }

          /* ➌ Render normal de tarjetas ------------------------ */
          return filtered.map((ev) => (
            <div
              key={ev.id}
              style={{
                position: "relative",
                marginBottom: 20,
                border: "1px solid #E5E7EB",
                borderRadius: 12,
                backgroundColor: "#F9FAFB",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                padding: "16px 20px 18px",
              }}
            >
              {/* ───── Esquina coloreada ───── */}
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: 0,
                  height: 0,
                  borderTop: `24px solid ${ev.color || "#6366F1"}`,
                  borderRight: "24px solid transparent",
                  borderTopLeftRadius: 12,
                }}
              />

              {/* ───── Título + menú ───── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 12,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: 18,
                    fontWeight: 600,
                    color: "#111827",
                  }}
                >
                  {ev.title}
                </h3>

                {ev.resource !== "festivo" && (
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: 22,
                      lineHeight: 1,
                      cursor: "pointer",
                      color: "#9CA3AF",
                    }}
                    onClick={(e) => handleMenuButton(e, ev)}
                  >
                    <i className="bi bi-three-dots"></i>
                  </button>
                )}
              </div>

              {/* ───── Hora ───── */}
              {ev.time && (
                <p
                  style={{
                    margin: "6px 0 0",
                    fontSize: 14,
                    color: "#6B7280",
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  <i className="bi bi-clock" style={{ fontSize: 13 }} />{" "}
                  {ev.time}
                </p>
              )}

              {/* ───── Nota ───── */}
              {ev.note && (
                <>
                  <p
                    style={{
                      margin: "14px 0 2px",
                      fontSize: 12,
                      color: "#6B7280",
                      fontWeight: 600,
                    }}
                  >
                    Nota
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 14,
                      color: "#4B5563",
                      lineHeight: 1.4,
                    }}
                  >
                    {ev.note}
                  </p>
                </>
              )}
            </div>
          ));
        })()}
      </div>

      {/* Menú contextual */}
      {ctxMenu.visible && (
        <div
          style={{
            position: "fixed",
            top: ctxMenu.y,
            left: ctxMenu.x,
            width: 144,
            background: "#FFFFFF",
            border: "1px solid #D1D5DB",
            boxShadow:
              "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
            zIndex: 50,
            borderRadius: 8,
            overflow: "hidden",
          }}
          onClick={() =>
            setCtxMenu({ visible: false, x: 0, y: 0, event: null })
          }
          onContextMenu={(e) => e.preventDefault()}
        >
          <button
            type="button"
            onClick={handleEdit}
            style={{
              display: "block",
              width: "100%",
              padding: "8px 16px",
              fontSize: 14,
              textAlign: "left",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
          >
            <i
              className="bi bi-pencil-fill"
              style={{ marginRight: 6, fontSize: 14 }}
            />
            Editar
          </button>

          <div style={{ height: 1, background: "#E5E7EB" }} />

          <button
            type="button"
            onClick={handleDelete}
            style={{
              display: "block",
              width: "100%",
              padding: "8px 16px",
              fontSize: 14,
              textAlign: "left",
              color: "#DC2626",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
          >
            <i
              className="bi bi-trash-fill"
              style={{ marginRight: 6, fontSize: 14 }}
            />
            Eliminar
          </button>
        </div>
      )}
    </Modal>
  );
}
